import { APIWorkspaceFolder, ArdoqId, AssetPayload } from '@ardoq/api-types';
import { createEntity, fetchEntities, renameEntity } from './api';

type MovedAssets = {
  targetFolderId: ArdoqId | null;
  content: AssetPayload[];
};

export const workspaceFolderApi = {
  moveAssets: createEntity<APIWorkspaceFolder[], MovedAssets>(
    'workspacefolder/asset/move'
  ),
  create: createEntity<APIWorkspaceFolder>('workspacefolder'),
  rename: renameEntity<APIWorkspaceFolder>('workspacefolder'),
  fetchAll: fetchEntities<APIWorkspaceFolder>('workspacefolder'),
};
